module.exports = __webpack_public_path__ + "img/db.84164376.svg";